module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About the Author")]), _vm._v(" "), _c('p', [_vm._v("Kjell Aas was a retired professor of University of Oslo, Norway (paediatrics, children and youth allergology, clinical immunology). He was the founder and Chief Physician of Oslo University Hospital, Voksentoppen Institute for children with allergies, asthma and other lung diseases.")]), _vm._v(" "), _c('p', [_vm._v("His MD work was the world’s first pure isolated allergen (cod protein). He was an honourable member of several national and international scientific societies and was granted an honorary doctorate at Gothenburg University in Sweden. He was decorated with a number of military and general honours. He had an extensive scientific production.")]), _vm._v(" "), _c('p', [_vm._v("He graduated from RNAF pilot school Canada and England, 1944 – 1945.")]), _vm._v(" "), _c('p', [_vm._v("He died in October 2016.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f37d542","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0